import { render, staticRenderFns } from "./UploadTable.vue?vue&type=template&id=0a197e8a"
import script from "./UploadTable.vue?vue&type=script&lang=js"
export * from "./UploadTable.vue?vue&type=script&lang=js"
import style0 from "./UploadTable.vue?vue&type=style&index=0&id=0a197e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports